import React, { useState, useEffect } from 'react';
import { 
  Box,  
  Typography, 
  Tabs,
  Tab,
  Grid,
  useMediaQuery,
} from '@mui/material';
import { CustomButton, CustomTooltip, StandardChip, StatusChip } from '../../../v2/MUI_custom_component';
import {  Sort } from '../../../components/icons';
import DynamicFilter, { FilterButton, SelectedFiltersDisplay } from '../../DyanamicFilter';
import IconReusable from '../../../components/IconReusable';
import ReusableMenu from '../../../v2/MUI_custom_component/Menu';
import GlassModal from '../../../v2/MUI_custom_component/Modal/GlassModal';
import BenefitCard from '../../../v2/Benefits/BenefitsRevamp/Components/BenefitCard';
import RewardsCard from './RewardsCard';
import PerformanceChart from './PerformanceChart';
import { toast } from 'react-toastify';
import { getNetworkFilterAction, getNetworkPerformanceAction, getNetworkRewardAction } from '../API/Action';
import { useNavigate } from 'react-router-dom';
import StatusBadge from '../../../v2/MUI_custom_component/Badge/StatusBadge';
import { getVerificationStatusLabel } from '../../../utils/settings';

// Reusable verification status label mapping


const NetworkCards = ({ role_image, networkCards, onTabChange, selectedTab: parentSelectedTab , badgeText, selectedCompanyEntity, selectedManufacturer}) => {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [roleTab, setRoleTab] = useState(parentSelectedTab || 0);
  
  // Sort related state
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [currentSort, setCurrentSort] = useState({ field: null, direction: 'asc' });
  
  // Filter related state
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filteredNetworkCards, setFilteredNetworkCards] = useState(networkCards || []);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [filterCount, setFilterCount] = useState(0);
  
  // Network details modal state
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectedNetworkCard, setSelectedNetworkCard] = useState(null);
  const [networkDetailsData, setNetworkDetailsData] = useState(null);
  const [rewardsData, setRewardsData] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loadingRewards, setLoadingRewards] = useState(false);
  const [networkFilters, setNetworkFilters] = useState(null);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [loadingNetwork, setLoadingNetwork] = useState(false);

  const getNetworkFilter = async () => {
    setLoadingFilters(true);
    const { data, error, message } = await getNetworkFilterAction();
    if (!error) {
      setNetworkFilters(data.filters);
      setLoadingFilters(false);
    } else {
      setLoadingFilters(false);
      return toast.error(message);
    }
  };
  useEffect(() => {
    getNetworkFilter();
  }, []);
  const sortMenuItems = [
    {
      label: 'Sort by Name',
      value: 'name_asc',
      visible: true,
      onClick: () => handleSort('name', 'asc')
    },
    {
      label: 'Sort by DSP Sale',
      value: 'dsp_sale_desc',
      visible: true,
      onClick: () => handleSort('dsp_sale', 'desc')
    },
    {
      label: 'Sort by Total Sales',
      value: 'total_sales_desc',
      visible: true,
      onClick: () => handleSort('ytd_sales', 'desc')
    },
    {
      label: 'Sort by Recent Sales',
      value: 'recent_sales_desc',
      visible: true,
      onClick: () => handleSort('product_sales', 'desc')
    },
  ];
  useEffect(() => {
    if (parentSelectedTab !== undefined && parentSelectedTab !== roleTab) {
      setRoleTab(parentSelectedTab);
    }
  }, [parentSelectedTab]);
  useEffect(() => {
    setFilteredNetworkCards(networkCards || []);
  }, [networkCards]);
  const applyFilters = (filters) => {
    console.log('Applied filters:', filters);
    setAppliedFilters(filters);
    
    let filtered = [...(networkCards || [])];

    // Apply search filter (special case)
    if (filters.searchQuery) {
      const query = filters.searchQuery.toLowerCase();
      filtered = filtered.filter(card => 
        card.name?.toLowerCase().includes(query) ||
        card.details?.some(detail => 
          detail.display_value?.toLowerCase().includes(query)
        )
      );
    }
    // Apply all other filters dynamically
    if (networkFilters && Array.isArray(networkFilters)) {
      networkFilters.forEach(filterConfig => {
        const filterKey = filterConfig.key;
        const selectedOptions = filters[filterKey];
        
        // Handle text filters (like search_text)
        if (filterConfig.type === 'text' && selectedOptions && typeof selectedOptions === 'string' && selectedOptions.trim() !== '') {
          const searchValue = selectedOptions.toLowerCase();
          filtered = filtered.filter(card => {
            // Search in card details for phone numbers or other relevant fields
            return card.details?.some(detail => 
              detail.display_value?.toLowerCase().includes(searchValue)
            ) || card.name?.toLowerCase().includes(searchValue);
          });
        }
        // Handle checkbox filters
        else if (filterConfig.type === 'checkbox' && selectedOptions && Array.isArray(selectedOptions) && selectedOptions.length > 0) {
          filtered = filtered.filter(card => {
            const cardValue = card[filterKey];
            const defaultValue = getDefaultValueForFilter(filterKey);
            return selectedOptions.includes(cardValue || defaultValue);
          });
        }
      });
    }

    setFilteredNetworkCards(filtered);

    let count = 0;
    if (filters.searchQuery) count++;
    
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        count += value.length;
      } else if (typeof value === 'string' && value.trim() !== '') {
        count += 1;
      }
    });
    
    setFilterCount(count);
  };
  const getDefaultValueForFilter = (filterKey) => {
    const defaultValues = {
      'umang_utsav': 'not_qualified',
      'active_status': 'active',
      'verification_status': 'not_verified'
    };
    return defaultValues[filterKey] || '';
  };
  const handleSortClick = (event) => {
    setSortAnchorEl(event.currentTarget);
  };
  const handleCloseSortMenu = () => {
    setSortAnchorEl(null);
  };
  const handleSort = (field, direction) => {
    setCurrentSort({ field, direction });
    handleCloseSortMenu();
  };
  const extractNumericValue = (value) => {
    if (!value) return 0;
    const numericMatch = value.match(/([0-9.,]+)/);
    if (!numericMatch) return 0;
    return parseFloat(numericMatch[1].replace(/,/g, '')) || 0;
  };
  const getSaleValue = (card, saleType) => {
    const detail = card.details?.find(d => 
      d.display_name?.toLowerCase().includes(saleType.toLowerCase())
    );
    return detail ? extractNumericValue(detail.display_value) : 0;
  };
  const applySorting = (cards) => {
    if (!currentSort.field) return cards;

    return [...cards].sort((a, b) => {
      let aValue, bValue;

      switch (currentSort.field) {
        case 'name':
          aValue = a.name?.toLowerCase() || '';
          bValue = b.name?.toLowerCase() || '';
          break;
        case 'dsp_sale':
          aValue = getSaleValue(a, 'DSP Sale');
          bValue = getSaleValue(b, 'DSP Sale');
          break;
        case 'ytd_sales':
          aValue = a.ytd_sales || 0;
          bValue = b.ytd_sales || 0;
          break;
        case 'product_sales':
          aValue = a.product_sales || 0;
          bValue = b.product_sales || 0;
          break;
        default:
          return 0;
      }

      if (currentSort.direction === 'asc') {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
      }
    });
  };
  const clearFilters = () => {
    setFilteredNetworkCards(networkCards || []);
    setAppliedFilters({});
    setFilterCount(0);
  };
  const fetchNetworkDetails = async (network_id, network_esi, selectedManufacturer, selectedCompanyEntity) => {
      const payload = {
        manufacturer_id: selectedManufacturer,
        company_esi_id: selectedCompanyEntity,
        network_id: network_id,
        network_esi_id: network_esi
      };
      setLoadingNetwork(true);
      const { data, error, message } = await getNetworkPerformanceAction(payload);
      setLoadingNetwork(false);
      if (!error) {
          setNetworkDetailsData(data);
      } else {
        return toast.error(message);
      }
  };
  const fetchRewardsData = async (network_id, network_esi, selectedManufacturer, selectedCompanyEntity) => {
    const payload = {
        manufacturer_id: selectedManufacturer,
        company_esi_id: selectedCompanyEntity,
        network_id: network_id,
        network_esi_id: network_esi
      };
    setLoadingRewards(true);
    const { data, error, message } = await getNetworkRewardAction(payload);
    setLoadingRewards(false);
    if (!error) {
          setRewardsData(data);
    } else {
        return toast.error(message);
    }
  };
  const handleViewDetails = (card) => {
    setSelectedNetworkCard(card);
    setOpenDetailModal(true);
    const network_id = card.id;
    const network_esi = card.esi_id;
    fetchNetworkDetails(network_id, network_esi, selectedManufacturer, selectedCompanyEntity);
    fetchRewardsData(network_id, network_esi, selectedManufacturer, selectedCompanyEntity);
  };
  const handleContactCall = (card) => {
    // Check if phone number is available in card details
    const phoneDetail = card.details?.find(detail => 
      detail.display_name?.includes("Contact")
    );
    
    if (phoneDetail && phoneDetail.display_value) {
      const phoneNumber = phoneDetail.display_value;
      
      const telUrl = `tel:${phoneNumber}`;
      try {
        window.open(telUrl, '_self');
      } catch (error) {
        navigator.clipboard.writeText(phoneNumber).then(() => {
          alert(`Phone number ${phoneDetail.display_value} copied to clipboard`);
        }).catch(() => {
          alert(`Contact: ${phoneDetail.display_value}`);
        });
      }
    } else {
      alert(`Contact information not available for ${card.name}`);
    }
  };
  const removeSpecificFilter = (filterKey, optionKey) => {
    const updatedFilters = { ...appliedFilters };
    if (filterKey === 'search') {
      updatedFilters.searchQuery = '';
    } else if (optionKey) {
      const current = updatedFilters[filterKey] || [];
      if (Array.isArray(current)) {
        updatedFilters[filterKey] = current.filter(k => k !== optionKey);
      } else {
        updatedFilters[filterKey] = '';
      }
    } else {
      // If no optionKey provided, clear the entire filter
      const filterConfig = networkFilters?.find(f => f.key === filterKey);
      if (filterConfig?.type === 'text') {
        updatedFilters[filterKey] = '';
      } else {
        updatedFilters[filterKey] = [];
      }
    }
    applyFilters(updatedFilters);
  };
  const roles = [...new Set(networkCards?.map(card => card.role) || [])];
  const roleLabels = {
    'influencer': 'Influencer',
    'sub-dealer': 'Sub-Dealer'
  };
  const filteredCardsByRole = filteredNetworkCards?.filter(card => 
    roles.length > 0 && roleTab < roles.length ? card.role === roles[roleTab] : true
  ) || [];
  const filteredCards = filteredCardsByRole.filter(card => {
    if (selectedTab === 0) return true;
    if (selectedTab === 1) return card.verification_status === 'Verified';
    return true;
  });
  const sortedAndFilteredCards = applySorting(filteredCards);
  const handleRoleTabChange = (event, newValue) => {
    setRoleTab(newValue);
    setSelectedTab(0);
    
    // Clear all filters when tab changes
    clearFilters();
    
    if (onTabChange) {
      onTabChange(newValue);
    }
  };
  const renderNetworkCard = (card, index, ) => (
    <Grid item xs={12} md={6}>
      <Box key={index} sx={{ background: '#fff', padding:1, borderRadius: 2 , position: 'relative'}}>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Box sx={{
            backgroundColor: "#F7F7F7",
            borderRadius: 2,
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
              <Box
                  component={'img'}
                  src={role_image}
                  alt="network"
                  sx={{ width: 32, height: 32 }}
              />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography variant="labelD">
                {card.name}
              </Typography>
                {card.umang_utsav === 'qualified' && (
                  <CustomTooltip title={badgeText} placement="top" variant='nuetral' size='small'>
                      <Box sx={{ display: 'inline-block', position: 'absolute', right: 0 , zIndex:1, cursor: 'pointer' }}>
                        <IconReusable name="Qualified" size={24} color="#1976d2" />
                      </Box>
                  </CustomTooltip>
                )}
            </Box>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'end',
                justifyContent: 'space-between'
              }}
            >
              <Box>
                {card.details?.map((detail, idx) => (
                  <Typography
                    key={idx}
                    variant="body2"
                    sx={{
                      color: '#666',
                      fontSize: '0.875rem',
                      mb: 0.5
                    }}
                  >
                    <strong>{detail.display_name}:</strong> {detail.display_value}
                  </Typography>
                ))}
              </Box>
              <Box 
                sx={{ cursor: 'pointer' }}
                onClick={() => handleContactCall(card)}
              >
                <IconReusable name="Call1" size={24} color="#995A00" />
              </Box>
            </Box>
            
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <StatusBadge 
              label={getVerificationStatusLabel(card.verification_status)} 
              status={card.verification_status} 
              size={isMobile ? 'small' : 'medium'}
            />
            {card.influencer_type && (
              <StandardChip
                label={card.influencer_type}
                size="small"
                height="unset"
                sx={{
                  pointerEvents: 'none',
                  padding: '4px 8px'
                }}
              />
            )}
          </Box>
          <Box>
            <CustomButton
              variant="text"
              label={'View Details'}
              color='primary'
              size='small'
              onClick={() => handleViewDetails(card)}
            />
          </Box>
        </Box>
        {card.kyc_verified_show && (
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <CustomButton
              fullWidth
              variant="filled"
              color='primary'
              label='Verify KYC'
            />
          </Box>
        )}
      </Box>
    </Grid>
  );
  const networkDetailModal = () => (
    <GlassModal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        showHeader={true}
        title="Buyer Details"
        scrollable={true}
        maxWidth="600px"
        zIndex={2}
    >
      {(loadingDetails || loadingRewards) ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography>Loading network details...</Typography>
        </Box>
      ) : (networkDetailsData || rewardsData) ? (
        <Box sx={{ py: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
              <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column'}}>
                  <Typography variant="h2">
                    {networkDetailsData?.buyer_details?.name || 'N/A'}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                     <Typography variant="labelM">Phone</Typography>
                     <Typography variant="p3">{networkDetailsData?.buyer_details?.phone || 'N/A'}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                     <Typography variant="labelM">Address</Typography>
                     <Typography variant="p3">
                       {networkDetailsData?.buyer_details?.address || 'N/A'} {networkDetailsData?.buyer_details?.city ? `${networkDetailsData.buyer_details.city}, ` : ''}{networkDetailsData?.buyer_details?.state || ''} {networkDetailsData?.buyer_details?.pincode ? `- ${networkDetailsData.buyer_details.pincode}` : ''}
                     </Typography>
                  </Box>
              </Box>
              <Box sx={{ mr:2, cursor: 'pointer' }}>
                <IconReusable name="Call1" size={24} color="#995A00" />
              </Box>
          </Box>
          {networkDetailsData?.performance_history && (
            <PerformanceChart performanceData={networkDetailsData.performance_history} />
          )}
          {networkDetailsData?.sell_products && (
            <Box>
              <CustomButton
                fullWidth
                variant="filled"
                color="primary"
                label="Sell Products"
                onClick={() => navigate('/inventory')}
              />
            </Box>
          )}
          
          {networkDetailsData?.network && networkDetailsData.network.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 ,}}>
              <Typography variant="h2">
                Network
              </Typography>
              <Box sx={{ display: 'flex', bgcolor: '#FFF', p: 2, borderRadius: 2 }}>
                {networkDetailsData.network.map((item, index) => (
                  <Box 
                    key={index}
                    sx={{ 
                      textAlign: 'center',
                      flex: 1,
                      borderRight: index < networkDetailsData.network.length -1 ? '2px solid #D9D9D9' : 'none'
                    }}
                  >
                    <Typography variant="labelM" sx={{ color: '#666' }}>
                      {item.display_name}
                    </Typography>
                    <Typography variant="h3">
                      {item.value}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
          {rewardsData?.benefits && rewardsData.benefits.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="h2">
                Benefits
              </Typography>
              <Grid container spacing={2}>
                {rewardsData.benefits.map((benefit, index) => (
                  <Grid item xs={6} key={index}>
                    <BenefitCard 
                      benefit={benefit} 
                      selectedManufacturer={selectedManufacturer} 
                      selectedCompanyEntity={selectedCompanyEntity}
                      sx={{ minHeight: 'unset', background: 'transparent', border: '1px solid #FFF' }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          {rewardsData?.rewards && rewardsData.rewards.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="h2">
                Rewards
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1}}>
                {rewardsData.rewards.map((reward, index) => (
                  <RewardsCard key={index} reward={reward} />
                ))}
              </Box>
            </Box>
          )}
        </Box>
      ) : (
        <Box sx={{ textAlign: 'center', py: 4,zIndex:2 }}>
          <Typography>No data available</Typography>
        </Box>
      )}
    </GlassModal>
  );

  return (
    <Box>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        gap: 2,
        mb: 1
      }}>

      
        {roles.length > 1 && (
          <Box>
            <Tabs
              value={roleTab} 
              onChange={handleRoleTabChange}
              sx={{ 
                  p: '0 !important',
                  borderBottom: 1, 
                  borderColor: 'divider',
              }}
            >
              {roles.map((role, index) => (
                <Tab 
                  key={role} 
                  label={roleLabels[role] || role}
                  value={index}
                  sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: { xs: '13px', md: '16px' },
                  }}
                />
              ))}
            </Tabs>
          </Box>
        )}

        <Box sx={{ display: 'flex',}}>
          <CustomButton 
            endIcon={<Sort />}
            variant="text"
            label={'Sort'}
            color='neutral'
            size='small'
            onClick={handleSortClick}
          />
          <FilterButton 
            onOpenFilter={() => setFilterModalOpen(true)}
            activeFilterCount={filterCount}
            label="Filter"
            size='small'
            variant="text"
            color='neutral'
          />
        </Box>
      </Box>
      <SelectedFiltersDisplay
        appliedFilters={appliedFilters}
        filterConfig={networkFilters || []}
        onRemoveFilter={removeSpecificFilter}
        onClearAll={clearFilters}
        showClearAll={false}
      />

      
      {/* Network Cards List */}
      <Grid container spacing={2}>
        {sortedAndFilteredCards?.map((card, index) => renderNetworkCard(card, index))}
      </Grid>

      {/* Sort Menu */}
      <ReusableMenu
        anchorEl={sortAnchorEl}
        open={Boolean(sortAnchorEl)}
        onClose={handleCloseSortMenu}
        menuItems={sortMenuItems}
        sx={{ mt: 2 }}
      />

      <DynamicFilter
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        title="Filter Network"
        filterConfig={networkFilters || []}
        initialFilters={appliedFilters}
        onApply={applyFilters}
        onClear={clearFilters}
        showSearch={true}
        showDateRange={false}
        showSort={false}
      />
      
      {/* Network Details Modal */}
      {networkDetailModal()}
    </Box>
  );
};

export default NetworkCards;